const register = {
  loginCredentials: "Kredensial Masuk", // translated 
  companyInformation: "informasi perusahaan", // translated 
  contactDetails: "Detail Kontak", // translated 
  businessName: "Nama Bisnis", // translated 
  businessAddress: "Alamat bisnis", // translated 
  registrationCode: "Kode registrasi", // translated 
  businessRegistrationNumber: "Nomor Registrasi Bisnis", // translated 
  websiteUrl: "alamat situs web", // translated 
  mobilePhone: "Telepon genggam", // translated 
  regionStateProvince: "Wilayah/Negara Bagian/Provinsi", // translated 
  legalTitle: "Judul legal", // translated 
  city: "Kota", // translated 
  postalCode: "Kode Pos", // translated 
  registrationSuccess: "Registrasi berhasil.", // translated 
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Silakan tunggu beberapa saat dan Anda akan diarahkan ke halaman beranda.", // translated 
};


export default register;
